import request from '@/utils/request'

const url = '/home/invoicingmoney/'
const api = {
  getInvoicingMoneyList (data) {
    return request({
      url: url + 'getInvoicingMoneyList',
      method: 'post',
      data
    })
  },
  getInvoicingList () {
    return request({
      url: url + 'getInvoicingList',
      method: 'post'
    })
  },
  importInvoicingMoney (data) {
    return request({
      url: url + 'importInvoicingMoney',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  saveInvoicingMoney (data) {
    return request({
      url: url + 'saveInvoicingMoney',
      method: 'post',
      data
    })
  },
  export (data) {
    return request({
      url: url + 'export',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/invoicingMoney.js